import styled from 'styled-components';
import { H3 } from 'components/typography';
import { withModifiers } from 'utils/styles';
import { color } from 'styles/settings';

export const DropZone = styled.div`
  height: 200px;
  width: 200px;
  background-color: #fff;
  border: 2px dashed rgb(187, 186, 186);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 16px;
  cursor: pointer;

  ${withModifiers('isDisabled')`
    cursor: not-allowed;
  `}

  ${withModifiers('invalid')`
    border-color: ${color.ui.danger};
  `}
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const Icon = styled.span`
  opacity: 0.3;
  height: 64px;
  width: 64px;
`;

export const Label = styled(H3)`
  ${withModifiers('$invalid')`
    color: ${color.ui.danger};
  `}
  padding: 0 30px;
  text-align: center;
`;
